<template>
  <Stack
    v-if="recommendations?.length"
    gap="2"
  >
    <Callout
      v-for="(rec, index) in recommendations"
      :key="index"
      :status="getPriorityStatus(rec.priority)"
      :icon="'fas fa-' + rec.icon"
    >
      {{ rec.message }}
    </Callout>
  </Stack>
</template>

<script setup>
import { Callout, Stack } from '@stakeui';

defineProps({
  recommendations: {
    type: Array,
    default: () => ([]),
  },
});

const getPriorityStatus = priority => {
  switch (priority.toLowerCase()) {
    case 'high':
      return 'danger';
    case 'medium':
      return 'warning';
    case 'low':
      return 'info';
    default:
      return 'info';
  }
};
</script>
